var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCd = function SvgIconCd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "m6.505 22.67 8.816-7.35 7.35-8.816a12.05 12.05 0 0 0-5.169-5.172L8.68 8.679 1.333 17.5a12.05 12.05 0 0 0 5.172 5.169"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M20.485 20.485c3.786-3.786 4.513-9.472 2.182-13.988l-16.17 16.17c4.516 2.33 10.202 1.604 13.988-2.182"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M3.514 3.514C-.272 7.3-.998 12.985 1.332 17.502l16.17-16.17C12.986-1 7.3-.272 3.514 3.514"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconCd;